import * as React from 'react';
import {
    Buttons,
    ButtonProperties,
    PriorityIcon,
    Dropdown,
    ButtonTrigger
} from '@priority-software/priority-style-react';

interface MultiButtonProps {
    /** JSX element that discribes the main action button */
    button: JSX.Element;
    /** JSX elements to render inside dropdown menu */
    children: JSX.Element | JSX.Element[];
    /** props to adjust the trigger button */
    triggerProps: ButtonProperties;
    dropdownClassName?: string;
}

export const MultiButton = ({
    button,
    children,
    triggerProps,
    dropdownClassName
}: MultiButtonProps) => {
    return (
        <Buttons>
            {button}
            <Dropdown
                openingSide="leftSide"
                className={dropdownClassName}
                closeOnBlur
                trigger={
                    <ButtonTrigger
                        rotateIcon={PriorityIcon.arrowDropDown}
                        rotate="180deg"
                        {...triggerProps}
                    />
                }
            >
                <Dropdown.Content>{children}</Dropdown.Content>
            </Dropdown>
        </Buttons>
    );
};
